module.exports = __webpack_public_path__ + "img/Nav_Fold_Dark.5e2062d7.svg";